import React, { useEffect } from "react";
import Card from "components/common/Card";
import Button from "components/semantic/Button";
import { PolicyDetails } from "./components/Preview";
import { getHealthQualityThunk } from "store/thunk/kyp.thunk";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "utils/hooks";

export const HealthPolicyPreview = () => {
  const dispatch = useAppDispatch();
  const param: any = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getHealthQualityThunk(param?.policyId));
  }, [dispatch, param]);

  return (
    <div>
      <h1 className="text-xl sm:text-2xl font-extrabold mb-4 sm:mb-6 ">Your Health Policy Preview</h1>

      <Card className="w-full flex flex-col items-center" parentClassName="rounded-md mb-7 md:mb-0 md:rounded-lg border border-gray-300 shadow-none">
        <PolicyDetails />

        <div className="border-t w-full md:flex justify-center items-center py-4 px-6 hidden">
          <Button title="CONFIRM" className="w-full sm:w-auto" onClick={() => navigate("/kyp/review-policy/" + param?.policyId)} />
        </div>
      </Card>
      <Card className="w-full fixed bottom-0 left-0 rounded-t-[15px] bg-white flex md:hidden justify-center py-5" parentClassName={`border-2 border-gray-300 shadow-none `}>
        <Button title="CONFIRM" className="mx-0" onClick={() => navigate("/kyp/review-policy/" + param?.policyId)} />
      </Card>
    </div>
  );
};
